<template>
    <div style="width: 100%; height: 100%; position: relative;">

      <div class="container" style="height: 50px;" v-if="showTop">
        <div class="row">
          <div class="col-8 text-left" style="height: 50px; line-height: 50px; font-weight: bold; font-size: 25px;">
            {{merchant.title}}
          </div>
          <div class="col-4 text-right" style="height: 50px; line-height: 50px;font-size: 20px;">

            <span v-on:click="closeView">Close</span>
          </div>
        </div>
      </div>
      <div class="container" style="height: 40px;">
        <div class="row" v-if="menuType === 'single'">
          <div class="col-12 text-left">
            {{merchant.address}}
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-6">
            <label class="form-control menu-type-btn" v-bind:class="{'selected': menuType === 'dineIn'}" v-on:click="changeMenuType('dineIn')">Restaurant</label>
          </div>
          <div class="col-6">
            <label class="form-control menu-type-btn" v-bind:class="{'selected': menuType === 'takeaway'}" v-on:click="changeMenuType('takeaway')">Takeaway</label>
          </div>
        </div>
      </div>
      <div class="container" style="height: 40px;">
        <div class="row" style="min-height:40px;border-bottom:1px solid #efeff6;" v-if="merchant != false && categories != undefined">
          <div class="col-12 hide-scrollbar horizontal-scroll-container" id="cat-container" style="overflow-x: scroll;scroll-behavior: smooth;-webkit-overflow-scrolling: touch;">
            <ul class="nav nav-tabs" >
              <li v-for="(cat, index) in categories" ><a class="button-outlined-container button-text cat-button" v-bind:class="{'active': index == 0}" :id="'cat-'+cat.id" v-on:click="onCatClicked(index)" data-toggle="tab" :href="'#cat-' + cat.id">
                <span v-if="cat.public_name !== null && cat.public_name.length > 0">{{cat.public_name}}</span><span v-else>{{cat.name}}</span>
              </a></li>
            </ul>
          </div>
        </div>
      </div>
      <div style="height: calc(100% - 170px); overflow-y: auto;" v-bind:style="[ showTop == false ? {'height': 'calc(100% - 80px)'} : '']" v-on:scroll="handleScroll" id="menu-page">
        <div class="container" v-for="cat in categories" :id="'cat-menu-container-' + cat.id">
          <div class="row" :id="'category-title-'+cat.id">
            <div class="col-12 text-left" style="min-height: 40px; margin-top:10px; font-size: 20px; background: #eee;">
              <div style="line-height: 40px;">
              <strong><span v-if="cat.public_name !== null && cat.public_name.length > 0">{{cat.public_name}}</span><span v-else>{{cat.name}}</span></strong>
              </div>
              <div class="category-section-description" style="padding-left: 0;" v-if="cat.description !== undefined && cat.description !== null && cat.description.length > 0">{{cat.description}}</div>
            </div>
          </div>
          <div class="row" style="padding-bottom: 30px;">
            <div class="col-12 col-md-6" v-for="menu in cat.list">
              <div class=" menu-view-item-card">
                <div class="merchant-card-wrapper">

                  <div class="menu-card-info" style="position: relative;">
                    <div class="menu-card-title">
                      <span v-if="menu.public_name == null || menu.public_name.length == 0">{{menu.name}}</span><span v-else>{{menu.public_name}}</span>
                      <span v-if="(menu.productType != undefined && menu.productType != null && menu.productType === 'Alcohol') || (menu.alcohol != undefined && menu.alcohol == true)" class="alcohol"> <i class="fas fa-beer"></i></span>

                    </div>
                    <div class="icon-container"  v-if="menu.icons.length > 0">
                      <div v-for="icon in menu.icons" v-if="icon.selected == true" class="icon-item" v-bind:style="{backgroundImage: 'url(' + icon.url + ')'}"/>

                    </div>
                    <p class="menu-item-description" style="margin-top:10px;" v-if="menu.description != null"><span v-html="menu.description.replace(/(?:\r\n|\r|\n)/g, '<br>')"></span></p>
                    <div class="menu-item-description" style="margin-top: 10px;" v-if="menu.ingredients !== null && menu.ingredients.length > 0">
                      <b>Ingredients</b><br/>
                      {{menu.ingredients}}
                    </div>
                    <div class="menu-item-price" style="margin-top:10px;">
                      <span v-html="getPrice(menu)"></span>
  <!--                    <span v-if="menu.soldOut == 1" style="color:#FF795C;"><br>Sold Out</span>-->
  <!--                    <span v-if="menu.soldOut == 0 && menu.pricePoints > 0 &&-->
  <!--                            (order == false || order.pointsUsed == 0) &&-->
  <!--                            userPoint != undefined && userPoint != false && userPoint.balance > 0 && userPoint.balance > menu.pricePoints">-->
  <!--                              or <span class="points-usable-price" >{{menu.pricePoints}} {{points.unitTitle}}s</span>-->
  <!--                            </span>-->

                      <span v-if="menu.tableAvailable == false" style="color:#FF795C;"><br>{{menu.tableMessage}}</span>
                      <span v-if="menu.min_order > 1" style="color:#FF795C;"><br>Minimum {{menu.min_order}} <span v-if="menu.groupTags != null && menu.groupTags.length > 0">{{menu.groupTags}}</span></span>
                    </div>

  <!--                  <div v-if="menu.recommended == 1" style="height:40px;line-height: 40px;">-->
  <!--                    <span style="background-color: #FD7474; color:white; font-weight: bold; padding:5px 10px 5px 10px; border-radius:20px;">Recommended</span>-->
  <!--                  </div>-->
  <!--                  <div v-if="menu.popular == 1" style="height:40px;line-height: 40px;">-->
  <!--                    <span style="background-color: #6EC667; color:white; font-weight: bold; padding:5px 10px 5px 10px; border-radius:20px;">Popular</span>-->
  <!--                  </div>-->
                  </div>
                  <div class="menu-card-image" v-if="menu.imgs !== null && menu.imgs.length > 0" style="margin-top: 10px;"  v-bind:style="{backgroundImage: 'url(' + getThumbnamil(menu.imgs[0]) + ')'}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import {getMerchantMenus} from "../api/borium";

    export default {
      name: "MenuView",
      props: {
        merchant:{
          type:Object,
          default: function(){return null},
        },
        type: {
          type:String,
          default:''
        },
        onClose: {
          type:Function,
          default:null,
        },
        showTop: {
          type:Boolean,
          default:true,
        }
      },
      data() {
        return {
          categories:[],
          options:[],
          priceSchedules:[],
          discounts:[],
          priceOptions:[],
          lastSelections:[],
          menuType:'',
          preScrollPosition:0,
        }
      },
      created() {
        this.$data.menuType = this.type;
        if(this.merchant.webSetting !== undefined && this.merchant.webSetting.menu_type === '3') {
          this.$data.menuType = 'single';
        }
      },
      mounted() {
        this.getMenuList();
      },
      beforeDestroy() {
      },
      destroyed() {
      },
      watch:{
        merchant() {
          this.getMenuList();
        }
      },
      methods: {
        changeMenuType: function(newType) {
          if(this.$data.menuType === newType) {
            return;
          }
          this.$data.menuType = newType;
          this.getMenuList();
        },
        getThumbnamil: function(url, size = 300) {
          if(url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus") || url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/webs/")) {

            // if(parseInt(this.merchant.merchantId) === 1) {
            //   url = url.replace('https://storage.googleapis.com/menus-275719.appspot.com/merchants/', 'https://images.showmethemenu.net/merchants/');
            //   console.log("replace image to smtm");
            // }
            let words = url.split('.');
            words[words.length-2] += '_' + size + 'x' + size;
            return words.join('.');
          }
          return url;
        },
        onCatClicked: function(index) {
          let catDiv = document.getElementById("cat-" + index);
          if(catDiv != null) {
            let container = document.getElementById("cat-container");
            $("#cat-container").animate({scrollLeft : catDiv.offsetLeft}, 300);
            // container.scrollLeft = catDiv.offsetLeft -15;
          }

          let id = "category-title-" + this.$data.categories[index].id;


          let containerDiv = document.getElementById(id);
          let diff = -150;
          // if(containerDiv.offsetTop > 325) {
          // diff = 300;
          // }
          if(containerDiv != null) {
            $("#menu-page").animate({scrollTop : containerDiv.offsetTop + diff}, 300);
            // containerDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // console.log("scroll");
          }


        },
        handleScroll: function(event) {
          let restaurantPanelTop = event.srcElement.scrollTop;


          // if(this.$data.preScrollPosition < 200 && restaurantPanelTop >= 200) {
          //   // console.log("To center Pre position " + this.$data.preScrollPosition + " new " + restaurantPanelTop);
          //   $("#place-title").addClass("horizontal-center");
          //   $("#back-btn").addClass("left-top-back-dark");
          // } else if(this.$data.preScrollPosition >= 200 && restaurantPanelTop < 200) {
          //   $("#place-title").removeClass("horizontal-center");
          //   $("#back-btn").removeClass("left-top-back-dark");
          //   // console.log("To left Pre position " + this.$data.preScrollPosition + " new " + restaurantPanelTop);
          // }
          this.$data.preScrollPosition = restaurantPanelTop;
          // console.log("scroll position " + restaurantPanelTop);
          // if(restaurantPanelTop < -153) {
          //   restaurantPanelTop = -153;
          // }
          // if(this.$data.preScrollPosition > -153 && restaurantPanelTop == -153) {
          //   $("#nav-top").removeClass("transparent-background");
          // } else if(this.$data.preScrollPosition == -153 && restaurantPanelTop > -153) {
          //   $("#nav-top").addClass("transparent-background");
          // }
          // this.$data.preScrollPosition = restaurantPanelTop;
          // document.getElementById("restaurant-panel").style.top = restaurantPanelTop + 'px';

          let activeCat = null;
          for(let i = 0 ; i < this.$data.categories.length ; i++) {
            let catView = document.getElementById("cat-menu-container-" + this.$data.categories[i].id);
            if(catView != null) {
              let catBtn = document.getElementById("cat-" + this.$data.categories[i].id);
              if (this.isScrolledIntoView(catView)) {
                if($("#cat-" + this.$data.categories[i].id).hasClass("active") == false) {
                  catBtn.classList.add("active");
                  if (activeCat == null) {
                    activeCat = catBtn;
                  }
                }

              } else {
                if($("#cat-" + this.$data.categories[i].id).hasClass("active")) {
                  catBtn.classList.remove("active");
                }
              }
            }
          }

          if(activeCat != null) {
            // console.log("animate scroll");
            $("#cat-container").animate({scrollLeft: activeCat.offsetLeft - 15}, 100);
          }
        },
        isScrolledIntoView: function(el) {
          var rect = el.getBoundingClientRect();
          var elemTop = rect.top;
          var elemBottom = rect.bottom;

          if(elemTop <= 0 && elemBottom > window.innerHeight * 0.6) {
            return true;
          } else if(elemTop > 0 && elemTop <= window.innerHeight*0.6) {
            return true;
          } else if(elemTop >= 0 && elemBottom <= window.innerHeight) {
            return true;
          }
          return false;
        },
        getMenuList: function() {
          let self = this;
          this.$data.categories = [];
          this.$data.options = [];
          this.$data.priceSchedules = [];
          this.$data.discounts = [];
          this.$data.priceOptions = [];

          this.$data.lastSelections = [];

          let menuType = this.$data.menuType;
          if(menuType === 'single') {
            menuType = 'dineIn'
          }
          getMerchantMenus(this.merchant.merchantId, menuType)
          .then(function(data) {
            if(data.success === true) {
              self.populateMenus(data.list);
            }
          })
          .catch(function(err) {
            console.error('Request failed', err && err.response ? err.response.status : '');
          })
        },
        closeView: function() {
          if(this.onClose !== null) {
            this.onClose();
          }
        },
        getPrice: function(item) {

          let price = item.price;
          if (this.type == 'takeaway') {
            if (item.price_ta > 0) {
              price = item.price_ta;
            }
          } else if (this.type == 'delivery') {
            if (item.price_delivery > 0) {
              price = item.price_delivery;
            } else if (item.price_ta > 0) {
              price = item.price_ta;
            }
          } else if(parseInt(parseFloat(item.price)*100) === 0) {
            // console.log(item.name + "  price is zero");
            if(item.content !==  null && item.content.options !== undefined && item.content.options.length > 0) {
              for(let i = 0 ; i < item.content.options.length ; i++) {
                for(let j = 0 ; j < this.$data.options.length ; j++) {
                  if(parseInt(item.content.options[i].id) === parseInt(this.$data.options[j].id)) {
                    if(this.$data.options[j].content !== null) {
                      if(this.$data.options[j].content.required !== undefined && this.$data.options[j].content.required === true && this.$data.options[j].content.list !== undefined && this.$data.options[j].content.list !== null && this.$data.options[j].content.list.length > 0) {
                        let priceList = [];
                        for(let k = 0 ; k < this.$data.options[j].content.list.length ; k++) {
                          priceList.push(this.$data.options[j].content.list[k].field_name + ": £" + this.$data.options[j].content.list[k].field_price);
                        }

                        if(priceList.length > 0) {
                          return priceList.join("<br/>");
                        }
                      }
                    }
                    break;
                  }
                }
              }
            }
          }
          return "£" + Number(price).toFixed(2);
        },
        populateMenus: function(list) {
          for(let i = 0 ; i < list.length ; i++) {
            // console.log(list[i].name + " Type " + list[i].type + " id " + list[i].id);

            if(list[i].content != null && list[i].content.length > 0) {
              // console.log(list[i].content);
              list[i].content = JSON.parse(list[i].content);
            }
            if(list[i].list == undefined || list[i].list === null || list[i].list.length === 0) {
              continue;
            }
            // console.log("Passed");
            if(list[i].type === 'public_category' || list[i].type === 'category') {
              // console.log("Category " + list[i].name);
              if((list[i].isPublic == 0 || list[i].dineIn == 0) && this.type === 'dineIn') {
                continue;
              }
              if(list[i].list != null && list[i].list.length > 0) {
                for (let j = 0; j < list[i].list.length; j++) {

                  if(list[i].list[j].icons != null && list[i].list[j].icons !== 'Array' && list[i].list[j].icons.length > 0) {
                    list[i].list[j].icons = JSON.parse(list[i].list[j].icons);
                  } else {
                    list[i].list[j].icons = [];
                  }
                  list[i].list[j].alcohol = false;
                  if(list[i].list[j].content != null && list[i].list[j].content.length > 0) {
                    list[i].list[j].content = JSON.parse(list[i].list[j].content);
                    if(list[i].list[j].content.alcohol != undefined) {
                      list[i].list[j].alcohol = list[i].list[j].content.alcohol;
                    }
                  }
                  list[i].list[j].imgs = [];
                  if(list[i].list[j].image_url != null && list[i].list[j].image_url.length > 0) {
                    list[i].list[j].imgs = list[i].list[j].image_url.split(',');

                  }
                  list[i].list[j].tableAvailable = true;
                  list[i].list[j].tableMessage = "";
                }
                for (let j = list[i].list.length-1; j >= 0 ; j--) {

                  if((list[i].list[j].type != 'product' && list[i].list[j].type != 'set_product') || list[i].list[j].isPublic == 0) {
                    list[i].list.splice(j,1);

                    continue;
                  }
                  if(this.type === 'takeaway' && list[i].list[j].takeaway == 0) {
                    list[i].list.splice(j,1);
                    continue;
                  }
                  if(this.type === 'delivery' && list[i].list[j].delivery == 0) {
                    list[i].list.splice(j,1);
                    continue;
                  }

                  // if(list[i].list[j].tableTags.length > 0) {
                  //   let tags = list[i].list[j].tableTags.split(',');
                  //
                  //   // if(this.$data.tableTags.length == 0) {
                  //   //   // list[i].list.splice(j,1);
                  //   //   list[i].list[j].tableAvailable = false;
                  //   //   list[i].list[j].tableMessage = "Only Available on " + list[i].list[j].tableTags + " Table";
                  //   //   continue;
                  //   // }
                  //
                  //   let tableMatching = false;
                  //
                  //   for(let ti = 0 ; ti < tags.length ; ti++) {
                  //     for(let tti = 0 ; tti < this.$data.tableTags.length ; tti++) {
                  //       if(tags[ti] === this.$data.tableTags[tti]) {
                  //         tableMatching = true;
                  //         break;
                  //       }
                  //     }
                  //     if(tableMatching == true) {
                  //       break;
                  //     }
                  //   }
                  //
                  //   if(tableMatching == false) {
                  //     // list[i].list.splice(j,1);
                  //     list[i].list[j].tableAvailable = false;
                  //     list[i].list[j].tableMessage = "Only Available on " + list[i].list[j].tableTags + " Table";
                  //     continue;
                  //   }
                  // }

                }
              }
              this.$data.categories.push(list[i]);
            } else if(list[i].type === 'option') {
              if(this.type === 'takeaway' && list[i].takeaway == 0) {
                continue;
              }
              if(this.type === 'delivery' && list[i].delivery == 0) {
                continue;
              }
              this.$data.options.push(list[i]);
              if(list[i].list != null && list[i].list.length > 0) {
                for (let j = 0; j < list[i].list.length; j++) {
                  if(list[i].list[j].content != null && list[i].list[j].content.length > 0) {
                    list[i].list[j].content = JSON.parse(list[i].list[j].content);
                  }
                }
              }
              // console.log("option " + list[i].name);
              // console.log(list[i]);

            } else if(list[i].type === 'price_schedule') {
              this.$data.priceSchedules.push(list[i]);
            } else if(list[i].type === 'discount') {
              this.$data.discounts.push(list[i]);
            } else if(list[i].type === 'price_option') {
              this.$data.priceOptions.push(list[i]);
            }
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MenuView.vue